export default "__VITE_ASSET__97b391af__"